import { produce } from 'immer'
import { combineReducers } from 'redux'
import { AuditLogId, RoutingAuditLog } from 'shared/src/typings/RoutingAuditLog'
import { fetchRoutingAuditLogsAsyncV2 } from 'shared/store/actions/routingAuditLog'
import {
  hideRoutingAuditLogSidebar,
  showRoutingAuditLogSidebar,
} from 'shared/store/actions/sidebar'

import { createReducer } from 'typesafe-actions'

const routingAuditLogByConversationId = createReducer<
  Record<number, RoutingAuditLog[] | undefined>
>({}).handleAction([fetchRoutingAuditLogsAsyncV2.success], (state, action) => {
  const {
    payload: { conversationId, response },
  } = action

  return produce(state, (draft) => {
    draft[conversationId] = response
  })
})

const expandedAuditLogId = createReducer<AuditLogId>(null)
  .handleAction(showRoutingAuditLogSidebar, (_, { payload }) => {
    return payload
  })
  .handleAction(hideRoutingAuditLogSidebar, () => {
    return null
  })

export default combineReducers({
  routingAuditLogByConversationId,
  expandedAuditLogId,
})
